var layer = require('layui-layer');
var ResourceLoader = require("./resource-loader");
$(document).ready(function () {


    $('.tx').on("click", function () {    //page1头像 皮肤切换
        var index = $(this).index();
        var pos = $(this).data("pos");
        $('.tx').eq(index).addClass("txIcon").siblings().removeClass("txIcon");
        $(this).css("background-position-x", pos);
        if (index == 1) {
            $('.page1').addClass("page1Bg")
        } else {
            $('.page1').removeClass("page1Bg")
        }
    });
    $('.jn').on("click", function () {      //技能切换
        var index = $(this).index();
        $('.jn').eq(index).addClass("iconBg").siblings().removeClass('iconBg');
        $('.jn-js1').eq(index).show().siblings().hide();
    });

    $('.share').click(function () { //分享
        bShare.share()
    });
    bShare.addEntry({
        title: "大型军团竞技策略网游《铁甲雄兵》新武将_白起，震撼发布！点击查看详情>>>",
        summary: "白起，《战国策》作公孙起，曾在伊阕之战大破魏韩联军，攻陷楚国国都郢城，长平之战重创赵国主力，功勋赫赫，被封为武安君。",
        pic: "http://bos.ycgame.com/act/1806bq/images/210x220.jpg"
    });

    var resources = [
        {type: "video", elem: $(".rain")},
        {type: 'img', src: 'images/loading_bg.png'},
        {type: 'img', src: 'images/loading_bi.png'},
        {type: 'img', src: 'images/bg_01.png'},
        {type: 'img', src: 'images/bg_02.png'},
        {type: 'img', src: 'images/box1.jpg'},
        {type: 'img', src: 'images/box2.jpg'},
        {type: 'img', src: 'images/box3.jpg'},
        {type: 'img', src: 'images/carrousel1.jpg'},
        {type: 'img', src: 'images/carrousel2.jpg'},
        {type: 'img', src: 'images/carrousel3.jpg'},
        {type: 'img', src: 'images/carrousel4.jpg'},
        {type: 'img', src: 'images/con-top1.png'},
        {type: 'img', src: 'images/con-top2.png'},
        {type: 'img', src: 'images/con-top3.png'},
        {type: 'img', src: 'images/con-top4.png'},
        {type: 'img', src: 'images/con-top5.png'},
        {type: 'img', src: 'images/con-top6.png'},
        {type: 'img', src: 'images/css_sprites.png'},
        {type: 'img', src: 'images/hero-popup1.jpg'},
        {type: 'img', src: 'images/hero-popup2.jpg'},
        {type: 'img', src: 'images/hero-popup3.jpg'},
        {type: 'img', src: 'images/hero-popup4.jpg'},
        {type: 'img', src: 'images/hero-thumbnail1.png'},
        {type: 'img', src: 'images/hero-thumbnail2.png'},
        {type: 'img', src: 'images/hero-thumbnail3.png'},
        {type: 'img', src: 'images/home.png'},
        {type: 'img', src: 'images/hzts-btn1.jpg'},
        {type: 'img', src: 'images/hzts-btn2.jpg'},
        {type: 'img', src: 'images/hzyh1_01.jpg'},
        {type: 'img', src: 'images/hzyh1_02.jpg'},
        {type: 'img', src: 'images/hzyh2_01.jpg'},
        {type: 'img', src: 'images/hzyh2_02.jpg'},
        {type: 'img', src: 'images/icon1.jpg'},
        {type: 'img', src: 'images/icon2.jpg'},
        {type: 'img', src: 'images/jn-icon1.png'},
        {type: 'img', src: 'images/jn-icon2.png'},
        {type: 'img', src: 'images/jn-icon3.png'},
        {type: 'img', src: 'images/jn-icon4.png'},
        {type: 'img', src: 'images/line.png'},
        {type: 'img', src: 'images/logo.png'},
        {type: 'img', src: 'images/mouseActive.png'},
        {type: 'img', src: 'images/pf-bg2.jpg'},
        {type: 'img', src: 'images/pre.png'},
        {type: 'img', src: 'images/tx-icon1.png'},
        {type: 'img', src: 'images/tx-icon2.png'},
        {type: 'img', src: 'images/video-btn.jpg'},

    ];
    var loader = new ResourceLoader(resources);
    loader.onResourceReady = function () {
        var curProcess = parseInt((this.finished / this.resources.length) * 100) + "%";
        $('.loading2').css("height", curProcess);
        if (this.finished == this.resources.length) {
            $('.loading').remove();
        }
    };
    loader.load();

    var hor = $('.body-box')[0];        //启动horwheel
    horwheel(hor);
    var swiper = new Swiper('.swiper-container2', {
        pagination: '.swiper-pagination',
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        spaceBetween: 50,
//        paginationClickable: true,
    });
    var s;
    $(window).scroll(function () {
        s = scrollY;
    });
    $(".swiper-container1").mousewheel(function (e) { // 触底上滑
        if (s >= 210 && e.deltaY > 0) {
            $("html,body").animate({
                scrollTop: "0"
            }, 100);
        }
    });

    $('.video-btn ').on('click', function () {  // 视频播放
        $('.video').show();
        $('.video')[0].play();
        $(this).hide();
    });
    $('.hzyh-btn-active').on("click", function () { //画质升级 选择按钮
        var index = $(this).index();
        $('.hzyh-btn-active').eq(index).addClass("hzyh-btn1-p").siblings().removeClass("hzyh-btn1-p");
        $('.hzyh').eq(index).show().siblings().hide();
    });

    $('.p6-thumbnail div').click(function () {  // 英雄之路  弹出框大图
        var index = $(this).index();
        var json = {
            "title": "英雄之路",
            "id": 1,
            "start": index,
            "data": [
                {
                    "alt": "",
                    "pid": 0,
                    "src": "images/hero-popup1.jpg",
                    "thumb": ""
                }, {
                    "alt": "",
                    "pid": 1,
                    "src": "images/hero-popup2.jpg",
                    "thumb": ""
                }, {
                    "alt": "",
                    "pid": 1,
                    "src": "images/hero-popup3.jpg",
                    "thumb": ""
                }, {
                    "alt": "",
                    "pid": 1,
                    "src": "images/hero-popup4.jpg",
                    "thumb": ""
                }
            ]
        };

        function dialog() {
            layer.photos({
                photos: json,
                anim: 5
            })
        }

        dialog();
    });

    dragPanelMove(".mouseActive1", ".hzyz1-bg");
    dragPanelMove(".mouseActive2", ".hzyz2-bg");
    function dragPanelMove(thisDiv, otherDiv) { //拖动滑块
        var Move;
        var div_x;
        $(thisDiv).mousedown(function (e) {
            Move = true;
            div_x = e.pageX - $(thisDiv).position().left;
        });
        $(document).mousemove(function (e) {
            if (Move) {
                var obj = $(thisDiv);
                var moveLeft = e.pageX - div_x;
                console.log(moveLeft);
                if (moveLeft < 13) {
                    obj.css({
                        "left": '13px'
                    });
                } else if (moveLeft > 693) {
                    obj.css({
                        "left": "693px"
                    });
                } else {
                    obj.css({
                        "left": moveLeft
                    });
                    $(otherDiv).width(e.pageX - div_x + 90)
                }
            }
        }).mouseup(
            function () {
                Move = false;
            });
    }
});


//////////////////
// WEBPACK FOOTER
// ./index.js
// module id = 0
// module chunks = 0